class LoginService {
    private prepareLoginResponse: any

    public setPrepareLoginResponse(value: any) {
        this.prepareLoginResponse = value
    }

    public getPrepareLoginResponse(): any {
        return this.prepareLoginResponse
    }
}

export default new LoginService()
